/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type SyncIdentityProviderConnectionApplicationsRequestBody = {
  /**
   * Connection ID.
   */
  id: string;
};

/** @internal */
export type SyncIdentityProviderConnectionApplicationsRequestBody$Outbound = {
  id: string;
};

/** @internal */
export const SyncIdentityProviderConnectionApplicationsRequestBody$outboundSchema:
  z.ZodMiniType<
    SyncIdentityProviderConnectionApplicationsRequestBody$Outbound,
    SyncIdentityProviderConnectionApplicationsRequestBody
  > = z.object({
    id: z.string(),
  });

export function syncIdentityProviderConnectionApplicationsRequestBodyToJSON(
  syncIdentityProviderConnectionApplicationsRequestBody:
    SyncIdentityProviderConnectionApplicationsRequestBody,
): string {
  return JSON.stringify(
    SyncIdentityProviderConnectionApplicationsRequestBody$outboundSchema.parse(
      syncIdentityProviderConnectionApplicationsRequestBody,
    ),
  );
}
